// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-S3hhD","btnDetail":"index-btnDetail-1SLm6","active":"index-active-MFoY1"};